'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'
import { useConsentReady } from '@/hooks/useConsentReady'

declare global {
  interface Window {
    OBR?: any
    __OBR_LOADED__?: boolean
  }
}

export const Outbrain = () => {
  const consentReady = useConsentReady()
  const [loadScript, setLoadScript] = useState<boolean>(false)

  useEffect(() => {
    setLoadScript(consentReady && !window.__OBR_LOADED__)
  }, [consentReady])

  return (
    loadScript && (
      <Script
        id="outbrain-sdk"
        src="https://widgets.outbrain.com/outbrain.js"
        strategy="lazyOnload"
        async
        onLoad={() => {
          window.__OBR_LOADED__ = true
          console.log('[OBR] Outbrain script loaded')
        }}
        onError={(error) => {
          window.__OBR_LOADED__ = false
          console.error('[OBR] Error while loading Outbrain script ', error)
        }}
      />
    )
  )
}
